'use client';

import { Autocomplete, TextField } from '@mui/material';
import React from 'react';

export const FeeAutoComplete = ({ id, handleChange, feeOptions, selectedFee, disabled, error }) => (
	<Autocomplete
		options={feeOptions.map((fee) => ({ name: fee.feeName, id: fee.id }))}
		value={selectedFee ? { name: selectedFee.feeName, id: selectedFee.id } : ''}
		freeSolo
		disabled={disabled}
		size='medium'
		isOptionEqualToValue={(option, value) => {
			if (typeof option === 'string' || typeof value === 'string') return false;
			return option?.id === value?.id;
		}}
		getOptionLabel={(option) => {
			if (typeof option === 'string') return '';
			return option.name;
		}}
		renderOption={(props, option) => {
			if (!option || typeof option === 'string') return null;
			return (
				<li {...props} key={`${id}-${option.id}`}>
					{option.name}
				</li>
			);
		}}
		renderInput={(params) => (
			<TextField
				{...params}
				value={selectedFee?.id || ''}
				inputProps={{ ...params.inputProps, 'data-cy': id }}
				error={error}
			/>
		)}
		onInputChange={(_, __, reason) => {
			if (reason === 'clear') handleChange(null);
		}}
		onChange={(_, value) => {
			if (!value || typeof value === 'string') return;
			const findFee = feeOptions.find((fee) => fee.id === value.id);
			handleChange(findFee);
		}}
	/>
);
